import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate, useParams, useLocation, useRouteMatch } from 'react-router-dom';
import GridLayout from "react-grid-layout";
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";

export const CRUDBlock = ({ model, actionName, SaveBtnName = "Save" }) => {
    const { headers, requestBlockData, validation, root } = model;
    const rawState = headers.map(({ headerName }) => headerName).reduce((acc, curr) => (acc[curr] = "", acc), {});
    const [data, setData] = useState({ ...rawState });
    const [errors, setErrors] = useState({});
    const { id } = useParams();
    const history = useNavigate();
    const location = useLocation();



    const updateData = (headerName, value) => {
        setData(prev => ({ ...prev, [headerName]: value }));
    }

    const onChangeHandler = useCallback(
        ({ target: { name, value } }) => updateData(name, value), [data, setData]);


    //TODO: For now it’s empty, we dont have any backend for this function but it’s need preventDefault to not break other logic.
    const save = (e) => {
        e.preventDefault();
    };

    useEffect(() => {
        if (!!id) {
            if (!requestBlockData) {
                console.error("requestBlockData is not defined");
            } else {
                requestBlockData(id).then((resp) => {
                    const result = resp && resp.map(({ blockViewModel }) => blockViewModel);
                    setData(result);
                });
            }
        }
    }, [id, setData]);
    const editPage = (id, systemId) => () => history(`/LocalCampaign/edit/${systemId}`);
    return (

        <div className="backend__article-edit">
            <form onSubmit={(e) => save(e)}>
                <div className="row page-header">
                    <div className="columns small-9">
                        <h1 className="page__title">{actionName}</h1>
                    </div>
                    <div className="columns small-3">
                        <button type="submit" disabled className="button large expanded">{SaveBtnName}</button>
                    </div>
                </div>


                {data && data.length ?
                    <GridLayout className="blockPage__layout backend__table" cols={1} rowHeight={70} width={10000}>
                        {data.map((block, index) => <div key={block.systemId} className='blockPage__block' data-grid={{ x: 0, y: 0, w: 1, h: 2 }}>
                            <div className='gridster__block'>{block.templateId}{block.templateId === "LocalCampaign" ? <i className='edit' onClick={editPage(block.id, block.systemId)}></i> : null}{block.deleteEndpoint ? <i className='delete' onClick={deletePage(block.id)}></i> : null}</div>
                        </div>)}
                    </GridLayout>
                    : <h1 className='row page-notify'>
                        No blocks on this page
                    </h1>}
            </form>
        </div>
    )
}